import { createContext, useContext, useState } from "react";

const ContractContext = createContext();

export const ContractProvider = ({ children }) => {
  const [activeContractId, setActiveContractId] = useState(null);
  const [activeContractName, setActiveContractName] = useState(null);
  const [activeContractVersion, setActiveContractVersion] = useState(null);
  const [activeContractDocUrl, setActiveContractDocUrl] = useState(null);

  return (
    <ContractContext.Provider value={{ activeContractId, setActiveContractId, activeContractName, setActiveContractName, activeContractVersion, setActiveContractVersion, activeContractDocUrl, setActiveContractDocUrl }}>
      {children}
    </ContractContext.Provider>
  );
};

export const useContract = () => useContext(ContractContext);
